import { apiClient, safeApi } from '../../utils/axiosWithAuth';
import { ApiResponse } from '../../utils/axiosWithAuth';
import { StoreDTO, CreateStoreDTO, StorePaginationResponse } from '../../types/store';

export const createStoreAPI = (dto: CreateStoreDTO, userId: string) =>
  safeApi<{ uuid: string }>(() =>
    apiClient.post<ApiResponse<{ uuid: string }>>(`/stores?userId=${userId}`, dto)
  );

export const updateStoreAPI = (uuid: string, dto: Partial<CreateStoreDTO>) =>
  safeApi<StoreDTO>(() =>
    apiClient.put<ApiResponse<StoreDTO>>(`/stores/${uuid}`, dto)
  );

export const deleteStoreAPI = (uuid: string) =>
  safeApi<{ deleted: boolean }>(() =>
    apiClient.delete<ApiResponse<{ deleted: boolean }>>(`/stores/${uuid}`)
  );

export const fetchStoresAPI = (page = 1, limit = 10, search?: string) =>
  safeApi<StorePaginationResponse>(() =>
    apiClient.get<ApiResponse<StorePaginationResponse>>(
      `/stores?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}`
    )
  );

export const fetchOneStoreAPI = (uuid: string) =>
  safeApi<StoreDTO>(() =>
    apiClient.get<ApiResponse<StoreDTO>>(`/stores/${uuid}`)
  );

export const fetchStoresDropdownAPI = (search?: string) =>
  safeApi<StoreDTO[]>(() =>
    apiClient.get<ApiResponse<StoreDTO[]>>(`/stores/dropdown`, {
      params: search ? { search } : undefined
    })
  );

// Fetch all stores for transfers (no store-level filtering)
export const fetchAllStoresForTransfersAPI = (search?: string) =>
  safeApi<StoreDTO[]>(() =>
    apiClient.get<ApiResponse<StoreDTO[]>>(`/stores/all`, {
      params: search ? { search } : undefined
    })
  );
